// Cliente Supabase singleton.
//
// A anon key é pública por natureza — vai embutida no bundle e qualquer um que
// abra o DevTools a enxerga. O que protege o banco é o RLS, não o segredo da
// chave. A service_role key, essa sim, NUNCA entra aqui: ela ignora todo o RLS
// e só existe do lado dos jobs, em services/sync.

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env';

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!client) {
    client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'cleandental.session',
      },
    });
  }
  return client;
}
